module.exports = {
  CONNECTION_CONNECTED: 'CONNECTION_CONNECTED',
  CONNECTION_DISCONNECTED: 'CONNECTION_DISCONNECTED',
  RECONNECT_SUCCESS: 'RECONNECT_SUCCESS',
  RECONNECT_ERROR: 'RECONNECT_ERROR',
  RECONNECT_FAILED: 'RECONNECT_FAILED',
  RECONNECT_ABORT: 'RECONNECT_ABORT'
};
